<template>
  <ul>
    <li
      v-for="(firstItem, firstItemIndex) in getSafeItems(items)"
      :key="firstItem.sys.id"
      :data-id="slugify(firstItem.title)"
      class="ds-margin-y-48"
    >
      <h2 class="ds-heading-small ds-margin-bottom-12">
        <span v-if="showNumbers">
          {{ `${firstItemIndex + 1}. ` }}
        </span>
        {{ firstItem.title }}
      </h2>
      <RichText
        v-if="firstItem.text"
        :key="contentLocale"
        :data="firstItem.text"
        :content-locale="contentLocale"
        :table-type="tableType"
      />
      <ul v-if="firstItem.subchaptersCollection && firstItem.subchaptersCollection.items.length">
        <li
          v-for="(secondItem, secondItemIndex) in getSafeItems(firstItem.subchaptersCollection.items)"
          :key="secondItem.sys.id"
          class="ds-margin-y-24"
        >
          <h3 class="ds-heading-xsmall ds-margin-bottom-12">
            <span v-if="showNumbers">
              {{ `${firstItemIndex + 1}.${secondItemIndex + 1} ` }}
            </span>
            {{ secondItem.title }}
          </h3>
          <RichText
            v-if="secondItem.text"
            :key="contentLocale"
            :data="secondItem.text"
            :content-locale="contentLocale"
            :table-type="tableType"
          />
          <ul v-if="secondItem.subchaptersCollection && secondItem.subchaptersCollection.items.length">
            <li
              v-for="(thirdItem, thirdItemIndex) in getSafeItems(secondItem.subchaptersCollection.items)"
              :key="thirdItem.sys.id"
              class="ds-margin-y-24"
            >
              <h4 class="ds-heading-xsmall ds-margin-bottom-12">
                <span v-if="showNumbers">
                  {{ `${firstItemIndex + 1}.${secondItemIndex + 1}.${thirdItemIndex + 1} ` }}
                </span>
                {{ thirdItem.title }}
              </h4>
              <RichText
                v-if="thirdItem.text"
                :key="contentLocale"
                :data="thirdItem.text"
                :content-locale="contentLocale"
                :table-type="tableType"
              />
              <ul v-if="thirdItem.subchaptersCollection && thirdItem.subchaptersCollection.items.length">
                <li
                  v-for="(fourthItem, fourthItemIndex) in getSafeItems(thirdItem.subchaptersCollection.items)"
                  :key="fourthItem.sys.id"
                  class="ds-margin-y-24"
                >
                  <h5 class="ds-heading-xsmall ds-margin-bottom-12">
                    <span v-if="showNumbers">
                      {{ `${firstItemIndex + 1}.${secondItemIndex + 1}.${thirdItemIndex + 1}.${fourthItemIndex + 1} ` }}
                    </span>
                    {{ fourthItem.title }}
                  </h5>
                  <RichText
                    v-if="fourthItem.text"
                    :key="contentLocale"
                    :data="fourthItem.text"
                    :content-locale="contentLocale"
                    :table-type="tableType"
                  />
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script setup>
import { kebabCase } from 'lodash-es'
import RichText from './RichText.vue'

/**
 * Chapters
 * renders 4 level deep nested chapters list with option to show numbers
 * @property {Array} chapters - all chapter items
 * @property {Boolean} showNumbers - sets chapter numbers
 *
 * @example of a rendered list of chapters with numbers
 *  1. chapter title
 *  chapter text
 *  1.1 chapter title
 *  chapter text
 *  1.1.1 chapter title
 *  chapter text
 *  1.1.1.1 chapter title
 *  chapter text
 */

defineOptions({
  name: 'Chapters'
})

defineProps({
  items: { type: Array, required: true },
  showNumbers: { type: Boolean, required: true },
  contentLocale: { type: String, default: null },
  tableType: { type: String, default: '' }
})

const slugify = (name) => {
  return kebabCase(name)
}

const getSafeItems = (items) => {
  return items?.filter(Boolean) || []
}
</script>
